var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "super-collection__collection" },
    _vm._l(_vm.settings.collectionArray, function(collection, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "container super-collection__collection-container",
          class: {
            "super-collection__collection-container--with-slider": !collection.image
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "super-collection__collection-header",
              class: { "u-hidden-mobile-only": collection.image }
            },
            [
              _c(
                "div",
                { staticClass: "super-collection__collection-header-text" },
                [
                  _c(
                    "div",
                    { staticClass: "h3 super-collection__collection-title" },
                    [_vm._v(_vm._s(collection.title))]
                  ),
                  !collection.image
                    ? _c(
                        "a",
                        {
                          staticClass: "link link--primary",
                          attrs: { href: "/collections/" + collection.handle }
                        },
                        [
                          _c("span", { staticClass: "link__content" }, [
                            _vm._v("Shop All")
                          ]),
                          _c("icon", {
                            attrs: { name: "arrow_long_right", size: "20px" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              !collection.image
                ? _c(
                    "div",
                    { staticClass: "controls-container u-hidden-tablet-up" },
                    [
                      _c("div", { staticClass: "arrows" }, [
                        _c(
                          "div",
                          {
                            staticClass: "arrow arrow-prev",
                            on: {
                              click: function($event) {
                                return _vm.slidePrev(index)
                              }
                            }
                          },
                          [
                            _c("icon", {
                              attrs: { name: "chevron-left", size: "14px" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "arrow arrow-next",
                            on: {
                              click: function($event) {
                                return _vm.slideNext(index)
                              }
                            }
                          },
                          [
                            _c("icon", {
                              attrs: { name: "chevron-right", size: "14px" }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          collection.image
            ? _c(
                "div",
                { staticClass: "super-collection__collection-grid" },
                [
                  _c(
                    "div",
                    { staticClass: "super-collection__collection-hero" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "super-collection__collection-hero-content bg-white"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "super-collection__collection-hero-image-wrapper"
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "super-collection__collection-hero-image",
                                attrs: { src: collection.image }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "super-collection__collection-hero-text"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "super-collection__collection-title u-hidden-tablet-up"
                                },
                                [_vm._v(_vm._s(collection.title))]
                              ),
                              collection.description
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "super-collection__collection-desc body-sm body-lg-desktop-up"
                                    },
                                    [_vm._v(_vm._s(collection.description))]
                                  )
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "link link--primary u-hidden-mobile-only",
                                  attrs: {
                                    href: "/collections/" + collection.handle
                                  }
                                },
                                [
                                  _c("span", { staticClass: "link__content" }, [
                                    _vm._v("Shop All")
                                  ]),
                                  _c("icon", {
                                    attrs: {
                                      name: "arrow_long_right",
                                      size: "20px"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "link link--primary u-hidden-tablet-up",
                          attrs: { href: "/collections/" + collection.handle }
                        },
                        [
                          _c("span", { staticClass: "link__content" }, [
                            _vm._v("Shop All")
                          ]),
                          _c("icon", {
                            attrs: { name: "arrow_long_right", size: "20px" }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._l(_vm.gridCollection[collection.handle], function(
                    product
                  ) {
                    return _c(
                      "product-tile",
                      {
                        key: product.id,
                        staticClass: "super-collection__product-tile",
                        attrs: {
                          simple: true,
                          collectionHandle: collection.handle,
                          product: _vm.productWithoutVariants(product),
                          showMobileATC: false,
                          truncateTitle: false
                        }
                      },
                      [_vm._v(_vm._s(product.title))]
                    )
                  })
                ],
                2
              )
            : _c(
                "div",
                {
                  staticClass: "super-collection__collection-slider-container"
                },
                [
                  _c(
                    "swiper",
                    {
                      ref: "superCollectionSwiper_" + index,
                      refInFor: true,
                      attrs: {
                        options: _vm.swiperWithScrollbar(
                          "[data-scrollbar='super-collection-progress-" +
                            index +
                            "']"
                        )
                      }
                    },
                    _vm._l(_vm.collectionProducts[collection.handle], function(
                      product
                    ) {
                      return _c(
                        "swiperSlide",
                        {
                          key: product.id,
                          staticClass: "super-collection__collection-slide"
                        },
                        [
                          _c(
                            "product-tile",
                            {
                              staticClass: "super-collection__product-tile",
                              attrs: {
                                simple: true,
                                collectionHandle: collection.handle,
                                product: _vm.productWithoutVariants(product),
                                showMobileATC: false,
                                truncateTitle: false
                              }
                            },
                            [_vm._v(_vm._s(product.title))]
                          )
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "arrow arrow-prev bg-white",
                      on: {
                        click: function($event) {
                          return _vm.slidePrev(index)
                        }
                      }
                    },
                    [
                      _c("icon", {
                        attrs: { name: "arrow-left", size: "18px" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "arrow arrow-next bg-white",
                      on: {
                        click: function($event) {
                          return _vm.slideNext(index)
                        }
                      }
                    },
                    [
                      _c("icon", {
                        attrs: { name: "arrow-right", size: "18px" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
          _c("div", {
            staticClass: "super-collection__progress-bar",
            attrs: { "data-scrollbar": "super-collection-progress-" + index }
          })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }